'use strict';

frontendApp.directive('iioCharCode', function() {
    return {
        restrict:'A',
        replace: false,
        scope: {
            inputVal: "=iioCharCode"
        },
        link: function(scope, element, attrs) {

            scope.$watch('inputVal', function(val) {
                if (val) {
                    var intVal = parseInt(val);
                    element.val(String.fromCharCode(intVal));
                } else {
                    element.val("");
                }
            });
            
        }
    }
});
